module.exports = __webpack_public_path__ + "e27ecb4c2cb31703c28cfda37c951a27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiexin.png
// module id = 179
// module chunks = 1